import React, { useState } from "react"
import { Link } from "react-router-dom"
import Footer from "../components/Footer"
import { useMutation } from "@apollo/client"
import { ADD_USER } from "../graphql/AddUser"

const AddUser = () => {
  const [addUser] = useMutation(ADD_USER)
  const [addUserSuccess, setAddUserSuccess] = useState(false)
  const [errorMsg, setErrorMsg] = useState<string | null>(null)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const fname = event.currentTarget.fname.value
    const userName = event.currentTarget.userName.value
    const email = event.currentTarget.email.value
    const password = event.currentTarget.password.value
    const repassword = event.currentTarget.repassword.value

    if (password !== repassword) {
      setErrorMsg("Password Does not match!")
      return null
    }

    try {
      const result = await addUser({
        variables: {
          name: fname,
          userName: userName,
          email: email,
          password: password,
        },
      })
      if (result) {
        setErrorMsg("")
        setAddUserSuccess(true)
      }
    } catch (err: any) {
      setErrorMsg(err.message)
    }
  }

  const onChangeHandle = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    if (errorMsg !== null) {
      setErrorMsg(null)
    }
  }

  return (
    <div className='flex flex-col items-center justify-center h-screen bg-slate-800 text-slate-200'>
      <form
        className='flex flex-col px-12 py-6 space-y-2 rounded-lg w-80 bg-slate-900 drop-shadow-md-white'
        onSubmit={(event) => {
          handleSubmit(event)
        }}
      >
        <h2 className='mb-2 font-serif text-2xl text-center text-slate-50'>
          Create Account
        </h2>
        <div className='flex flex-col mb-1'>
          <label htmlFor='fname'>Name</label>
          <input
            className='p-1 rounded-sm text-slate-800'
            type='text'
            id='fname'
            required
            onChange={onChangeHandle}
          />
        </div>

        <div className='flex flex-col mb-1'>
          <label htmlFor='userName'>User Name</label>
          <input
            className='p-1 rounded-sm text-slate-800'
            type='text'
            id='userName'
            autoComplete='username'
            required
            onChange={onChangeHandle}
          />
        </div>

        <div className='flex flex-col mb-1'>
          <label htmlFor='email'>Email</label>
          <input
            className='p-1 rounded-sm text-slate-800'
            type='email'
            id='email'
            required
            onChange={onChangeHandle}
          />
        </div>

        <div className='flex flex-col mb-1'>
          <label htmlFor='password'>Password</label>
          <input
            className='p-1 rounded-sm text-slate-800'
            type='password'
            id='password'
            autoComplete='new-password'
            required
            onChange={onChangeHandle}
          />
        </div>

        <div className='flex flex-col mb-1'>
          <label htmlFor='repassword'>Repeat Password</label>
          <input
            className='p-1 rounded-sm text-slate-800'
            type='password'
            id='repassword'
            autoComplete='new-password'
            required
            onChange={onChangeHandle}
          />
        </div>

        <div>
          {addUserSuccess && (
            <div className='text-center text-green-500'>
              <p>User Created Succesfully!</p>
              <p>Please Sign In.</p>
            </div>
          )}
          {errorMsg && <p className='text-center text-red-400 '>{errorMsg}</p>}
        </div>

        <div className='mt-1 text-center'>
          <button
            type='submit'
            className='px-2 py-1 m-1 font-serif bg-red-400 rounded-sm hover:bg-red-500'
          >
            Create
          </button>
        </div>

        <div className='text-center underline p-2 border-t-[1px] '>
          <Link to={"/"}>Sign In</Link>
        </div>
      </form>
      <Footer />
    </div>
  )
}

export default AddUser
